export const replacePrimaryFamily = (familyIds, oldPrimaryFamilyId, newPrimaryFamilyId) => {
  const oldId = oldPrimaryFamilyId == null ? null : String(oldPrimaryFamilyId);
  const newId = newPrimaryFamilyId == null ? null : String(newPrimaryFamilyId);
  const preserved = (familyIds || []).map(String).filter((familyId) => familyId !== oldId && familyId !== newId);
  return newId ? [newId, ...preserved] : preserved;
};

export const movePrimaryFamily = (client, childId, familyId) =>
  client.put("/child-family/move", null, { params: { childId, familyId } });
